var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_27_20",
    "data-name": "Componente 27 \\u2013 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.619,
    height: 30,
    viewBox: "0 0 44.619 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_320",
    "data-name": "Rect\\xE1ngulo 320",
    width: 44.619,
    height: 30,
    fill: "#20164d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_242",
    "data-name": "Grupo 242",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_627",
    "data-name": "Trazado 627",
    d: "M36.054,30H8.565a4.1,4.1,0,0,0-.435-.082A8.893,8.893,0,0,1,.288,23.283C.183,22.871.1,22.455,0,22.04v-1.89a2.869,2.869,0,0,0,.091-.331,8.858,8.858,0,0,1,7.522-7.541c.7-.1,1.41-.094,2.114-.137A12.614,12.614,0,0,1,21.98,0,12.155,12.155,0,0,1,29.988,2.63a12.479,12.479,0,0,1,4.9,9.51c.745.047,1.459.044,2.159.143A8.878,8.878,0,0,1,37.812,29.7c-.578.135-1.172.2-1.758.3M22.28,26.783c4.432,0,8.863.021,13.295-.007a5.5,5.5,0,0,0,5.36-3.442,5.328,5.328,0,0,0-.977-6.06A5.48,5.48,0,0,0,33.794,15.7a1.609,1.609,0,0,1-2.233-1.807,13.6,13.6,0,0,0-.026-2.917,9.361,9.361,0,0,0-17.783-2.24,9,9,0,0,0-.724,5,1.663,1.663,0,0,1-.753,1.894,1.943,1.943,0,0,1-1.632.024,5.428,5.428,0,0,0-5.771,1.4,5.407,5.407,0,0,0-1.392,5.77A5.687,5.687,0,0,0,9.084,26.78c4.4.01,8.8,0,13.2,0",
    transform: "translate(0 0)",
    fill: "#20164d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_628",
    "data-name": "Trazado 628",
    d: "M25.037,14.691v.991q0,3.456,0,6.914a1.6,1.6,0,1,1-3.185.007q0-3.656,0-7.312v-.484l-.11-.075c-.618.634-1.214,1.292-1.866,1.888a2.28,2.28,0,0,1-1.023.541,1.481,1.481,0,0,1-1.6-.837,1.542,1.542,0,0,1,.287-1.834c.976-1,1.969-1.973,2.955-2.958.586-.586,1.167-1.178,1.762-1.757A1.576,1.576,0,0,1,24.6,9.766q2.355,2.325,4.683,4.677a1.586,1.586,0,0,1,.074,2.31,1.609,1.609,0,0,1-2.315-.052c-.641-.624-1.263-1.267-2-2.01",
    transform: "translate(-1.134 -0.614)",
    fill: "#20164d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3a507fc486e3ed3730e60f74c0e4cabe.svg";
export { ForwardRef as ReactComponent };